/**
 * ┌─────────────────────────────────────────────────────────────────────────────┐
 * │           RESERVATION DEFAULTS CALCULATION - INPUT PRIORITY                 │
 * └─────────────────────────────────────────────────────────────────────────────┘
 *
 * This utility calculates the default START TIME and DURATION for a new
 * reservation based on multiple input sources with the following priority:
 *
 * ┌─────────────────────────────────────────────────────────────────────────────┐
 * │                              INPUT SOURCES                                  │
 * ├─────────────────────────────────────────────────────────────────────────────┤
 * │                                                                             │
 * │   ┌─────────────────┐    ┌─────────────────┐    ┌─────────────────┐        │
 * │   │   MAP FILTER    │    │  OFFICE CONFIG  │    │  RESOURCE TYPE  │        │
 * │   │  (User Select)  │    │ (Admin Config)  │    │  (desk/room)    │        │
 * │   ├─────────────────┤    ├─────────────────┤    ├─────────────────┤        │
 * │   │ • mapStartDate  │    │ • startHour     │    │ • "desk"        │        │
 * │   │ • mapEndDate    │    │ • startMinutes  │    │ • "meeting_room"│        │
 * │   │ • timeMode      │    │ • endHour       │    │ • "workspace"   │        │
 * │   │   (live/manual) │    │ • endMinutes    │    │ • etc...        │        │
 * │   └────────┬────────┘    │ • deskDuration  │    └────────┬────────┘        │
 * │            │             │ • meetingRoom   │             │                 │
 * │            │             │   Duration      │             │                 │
 * │            │             └────────┬────────┘             │                 │
 * │            │                      │                      │                 │
 * │            └──────────────────────┼──────────────────────┘                 │
 * │                                   │                                        │
 * │                                   ▼                                        │
 * │                    ┌──────────────────────────┐                            │
 * │                    │ calculateReservation     │                            │
 * │                    │ Defaults()               │                            │
 * │                    └──────────────────────────┘                            │
 * │                                   │                                        │
 * │                                   ▼                                        │
 * │                    ┌──────────────────────────┐                            │
 * │                    │  OUTPUT: { startDate,    │                            │
 * │                    │           duration }     │                            │
 * │                    └──────────────────────────┘                            │
 * └─────────────────────────────────────────────────────────────────────────────┘
 *
 *
 * ┌─────────────────────────────────────────────────────────────────────────────┐
 * │                         START TIME CALCULATION                              │
 * ├─────────────────────────────────────────────────────────────────────────────┤
 * │                                                                             │
 * │                        ┌─────────────────┐                                  │
 * │                        │   timeMode?     │                                  │
 * │                        └────────┬────────┘                                  │
 * │                    ┌────────────┴────────────┐                              │
 * │                    ▼                         ▼                              │
 * │            ┌───────────────┐         ┌───────────────┐                      │
 * │            │  "live"       │         │  "manual"     │                      │
 * │            └───────┬───────┘         └───────┬───────┘                      │
 * │                    │                         │                              │
 * │                    ▼                         ▼                              │
 * │     ┌──────────────────────────┐    ┌──────────────────────┐               │
 * │     │ Use DATE from mapStart   │    │ Use mapStartDate     │               │
 * │     │ Use TIME from now()      │    │ exactly as provided  │               │
 * │     │                          │    │                      │               │
 * │     │ Example:                 │    │ Example:             │               │
 * │     │ mapStart = Jan 15, 9am   │    │ mapStart = Jan 15    │               │
 * │     │ now = Jan 14, 2:30pm     │    │            9:00am    │               │
 * │     │ result = Jan 15, 2:30pm  │    │ result = Jan 15      │               │
 * │     └──────────────────────────┘    │          9:00am      │               │
 * │                                     └──────────────────────┘               │
 * └─────────────────────────────────────────────────────────────────────────────┘
 *
 *
 * ┌─────────────────────────────────────────────────────────────────────────────┐
 * │                          DURATION CALCULATION                               │
 * ├─────────────────────────────────────────────────────────────────────────────┤
 * │                                                                             │
 * │   Step 1: Check if map filter time differs from office defaults             │
 * │                                                                             │
 * │            mapStart/End times          office default times                 │
 * │            ┌─────────────┐             ┌─────────────┐                      │
 * │            │ 10am - 2pm  │     vs      │ 9am - 5pm   │                      │
 * │            └──────┬──────┘             └──────┬──────┘                      │
 * │                   │                          │                              │
 * │                   └────────────┬─────────────┘                              │
 * │                                │                                            │
 * │                                ▼                                            │
 * │                   ┌────────────────────────┐                                │
 * │                   │  isTimeNotDefault()?   │                                │
 * │                   └───────────┬────────────┘                                │
 * │                   ┌───────────┴───────────┐                                 │
 * │                   ▼                       ▼                                 │
 * │           ┌───────────────┐       ┌───────────────┐                         │
 * │           │     TRUE      │       │     FALSE     │                         │
 * │           │ (User changed │       │ (Default time │                         │
 * │           │  the time)    │       │  selected)    │                         │
 * │           └───────┬───────┘       └───────┬───────┘                         │
 * │                   │                       │                                 │
 * │                   ▼                       ▼                                 │
 * │   ┌───────────────────────────┐  ┌───────────────────────────┐             │
 * │   │ USE MAP FILTER DURATION   │  │ USE TYPED DEFAULT DURATION│             │
 * │   │                           │  │                           │             │
 * │   │ duration = mapEnd - start │  │ if meeting_room:          │             │
 * │   │                           │  │   duration = roomDuration │             │
 * │   │ (Respect user's choice)   │  │ else:                     │             │
 * │   │                           │  │   duration = deskDuration │             │
 * │   └───────────────────────────┘  └───────────────────────────┘             │
 * │                                                                             │
 * │   NOTE: In "live" mode, mapEndDate is IGNORED - always uses typed default  │
 * └─────────────────────────────────────────────────────────────────────────────┘
 *
 *
 * ┌─────────────────────────────────────────────────────────────────────────────┐
 * │                              EXAMPLES                                       │
 * ├─────────────────────────────────────────────────────────────────────────────┤
 * │                                                                             │
 * │  Example 1: Manual mode, default office hours (9am-5pm), desk               │
 * │  ─────────────────────────────────────────────────────────────              │
 * │  Input:  mapStart=9am, mapEnd=5pm, resourceType=desk, deskDuration=8hrs     │
 * │  Check:  isTimeNotDefault(9am, 5pm) → FALSE (matches defaults)              │
 * │  Output: startDate=9am, duration=480min (8 hrs from deskDuration)           │
 * │                                                                             │
 * │  Example 2: Manual mode, custom hours, desk                                 │
 * │  ─────────────────────────────────────────────────────────────              │
 * │  Input:  mapStart=10am, mapEnd=2pm, resourceType=desk                       │
 * │  Check:  isTimeNotDefault(10am, 2pm) → TRUE (differs from 9am-5pm)          │
 * │  Output: startDate=10am, duration=240min (4 hrs from map filter)            │
 * │                                                                             │
 * │  Example 3: Manual mode, default hours, meeting_room                        │
 * │  ─────────────────────────────────────────────────────────────              │
 * │  Input:  mapStart=9am, mapEnd=5pm, resourceType=meeting_room, roomDur=1hr   │
 * │  Check:  isTimeNotDefault(9am, 5pm) → FALSE (matches defaults)              │
 * │  Output: startDate=9am, duration=60min (1 hr from meetingRoomDuration)      │
 * │                                                                             │
 * │  Example 4: Live mode (ignores map end time)                                │
 * │  ─────────────────────────────────────────────────────────────              │
 * │  Input:  mapStart=Jan15 9am, mapEnd=Jan15 5pm, now=Jan14 2:30pm             │
 * │  Output: startDate=Jan15 2:30pm, duration=typed default (ignores mapEnd)    │
 * │                                                                             │
 * └─────────────────────────────────────────────────────────────────────────────┘
 */

import { addMinutes, differenceInMinutes, format } from "date-fns";
import type { ResourceType } from "@gettactic/api";

export type ReservationTimeSettings = {
  startHour: number;
  startMinutes: number;
  endHour: number;
  endMinutes: number;
  deskDuration: number;
  meetingRoomDuration: number;
};

export type TimeMode = "live" | "manual";

export interface CalculateReservationDefaultsParams {
  /** Time mode - defaults to "manual" if undefined */
  timeMode: TimeMode | undefined;
  mapStartDate: Date | null;
  mapEndDate: Date | null;
  resourceType: ResourceType;
  defaultHours: ReservationTimeSettings;
  /** Override for current time, useful for testing */
  now?: Date;
}

export interface ReservationDefaults {
  startDate: Date | undefined;
  duration: number;
}

/**
 * Checks if the provided start/end times differ from office default times.
 * Returns true if either start or end time is different from defaults.
 */
export function isTimeNotDefault(
  defaultHours: ReservationTimeSettings,
  startDate: Date,
  endDate: Date
): boolean {
  const hhMMStart = format(startDate, "HH:mm");
  const hhMMEnd = format(endDate, "HH:mm");
  const defaultStartHHmm = `${defaultHours.startHour.toString().padStart(2, "0")}:${defaultHours.startMinutes.toString().padStart(2, "0")}`;
  const defaultEndHHmm = `${defaultHours.endHour.toString().padStart(2, "0")}:${defaultHours.endMinutes.toString().padStart(2, "0")}`;

  return hhMMStart !== defaultStartHHmm || hhMMEnd !== defaultEndHHmm;
}

/**
 * Calculates the default start time and duration for a new reservation
 * based on map filter settings and office defaults.
 *
 * Logic:
 * - In "live" mode: uses current time but preserves selected date from map filter
 * - In "manual" mode: uses the exact start time from map filter
 * - Duration is calculated based on:
 *   - Resource type (meeting rooms vs desks have different defaults)
 *   - Whether the map filter time differs from office defaults
 */
export function calculateReservationDefaults(
  params: CalculateReservationDefaultsParams
): ReservationDefaults {
  const {
    timeMode: timeModeParam,
    mapStartDate,
    mapEndDate,
    resourceType,
    defaultHours,
    now = new Date()
  } = params;

  // Default to "manual" if timeMode is undefined
  const timeMode = timeModeParam ?? "manual";

  let startDate: Date | undefined;

  // Calculate start date based on time mode
  if (timeMode === "live") {
    if (mapStartDate) {
      startDate = new Date(mapStartDate);
      startDate.setHours(
        now.getHours(),
        now.getMinutes(),
        now.getSeconds(),
        now.getMilliseconds()
      );
    } else {
      startDate = now;
    }
  } else {
    startDate = mapStartDate || undefined;
  }

  // Calculate duration
  if (!startDate) {
    return { startDate: undefined, duration: 60 };
  }

  const { meetingRoomDuration, deskDuration } = defaultHours;

  // Default duration in minutes (used for checking if map time is default)
  const defaultDurationMinutes = deskDuration * 60;

  // Duration based on resource type
  const isMeetingRoom = resourceType === "meeting_room";
  const typedDefaultDurationMinutes = isMeetingRoom
    ? meetingRoomDuration * 60
    : deskDuration * 60;

  // Calculate default end time
  const defaultEndTime = addMinutes(startDate, defaultDurationMinutes);

  // In live mode, don't use map end time
  const effectiveMapEndTime = timeMode === "live" ? null : mapEndDate;

  if (effectiveMapEndTime && mapStartDate) {
    const mapDuration = differenceInMinutes(effectiveMapEndTime, startDate);

    const timeIsNotDefault = isTimeNotDefault(
      defaultHours,
      mapStartDate,
      effectiveMapEndTime
    );

    if (timeIsNotDefault) {
      // Map time differs from default, use map duration
      return { startDate, duration: mapDuration };
    }
    // Map time matches default, use typed default duration
    return { startDate, duration: typedDefaultDurationMinutes };
  }

  // No end time from map filter, use default
  return { startDate, duration: typedDefaultDurationMinutes };
}
